import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IForm } from 'src/app/core/signup/form-data.interface';
import { environment } from 'src/environments/environment';
import { JwtService } from './jwt.service';

@Injectable({
  providedIn: 'root'
})
export class SignupService {
  readonly BASE_URL = environment.BASE_API_URL;
  constructor(
    private http: HttpClient,
    public jwtService: JwtService
  ) { }
  signUpAuth(data: IForm) {
    let headers = this.setHeaderLanguage()
    return this.http.post(`${this.BASE_URL}auth/users/`, data, { headers })
  }
  activationAccount(data: any, activation_status: boolean) {
    let headers = this.setHeaderLanguage()
    let formData = new FormData();
    if (activation_status) {
      formData.append('email', data.email);
      formData.append('code', data.code);
      return this.http.post(`${this.BASE_URL}auth/users/activation/`, formData, { headers })
    } else {
      formData.append('phone_number', data.phone_number?.replaceAll(' ', ''));
      formData.append('security_code', data.security_code);
      formData.append('session_token', data.session_token);
      return this.http.post(`${this.BASE_URL}auth/phone/verify/`, formData, { headers })
    }
  }
  resendActivationCode(data: string, activation_status: boolean) {
    let headers = this.setHeaderLanguage()
    let formData = new FormData();
    if (activation_status) {
      formData.append('email', data)
      return this.http.post(`${this.BASE_URL}auth/users/resend_activation/`, formData, { headers })
    } else {
      formData.append('phone_number', data.replaceAll(' ', ''))
      return this.http.post(`${this.BASE_URL}auth/phone/resend_activation/`, formData, { headers })
    }
  }
  setHeaderLanguage() {
    let headers = new HttpHeaders();
    headers = headers.append('Accept-Language', 'fa')
    return headers
  }
}
